import React, { memo, useEffect, useState } from "react";
import "./ActivityPdf.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

let activityList = [];
const ActivityPdf = memo((props) => {
  const [activityData, setActivityData] = useState([]);
  const [headers, setHeaders] = useState([]);

  //get interactive map data
  useEffect(() => {
    if (props && props.data) {
      setActivityData(props.data);
      setHeaders(props.keys);
    }
  }, [props && props.data]);

  const getActivityList = (data) => {
    activityList = [];
    let headRows = headers;
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      activityList.push(
        <TableRow key={index}>
          <TableCell>{element.profilename}</TableCell>
          {headRows.map(x => element.activitylist[x] ? <TableCell>{element.activitylist[x]}</TableCell> : <TableCell>-</TableCell>)}
        </TableRow>
      )
    }
    return activityList;
  }

  return (
    <div>
      <div className="table-design">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Profile Name</TableCell>
              {headers && headers.length > 0 ? (
                headers.map((data) => (
                  <TableCell className={data === "Others" ? 'others-width' : ''}>{data}</TableCell>
                  ))
              ) : ''}
            </TableRow>
          </TableHead>
          <TableBody>
            {activityData && activityData.length > 0 ? (
              getActivityList(activityData)
            ) : (
              <TableRow>
                <TableCell
                  style={{ textAlign: "center" }}
                  colSpan="5"
                  className="store-no-data"
                >
                  No records found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
});

export default ActivityPdf;
